<template>
  <div class="footer" :class="{auth: route.path != '/'}">
    <div v-if="userStore.isAuth" class="d-flex justify-space-between auth align-center">
      <div class="w-100">
        <v-hover>
          <template v-slot:default="{ props }">
            <div v-bind="props" class="footer-nav-content cursor-pointer" :class="{ active: route.path.indexOf('/profile') != -1 }" @click="goToHome">
              <v-icon :icon="HomeIcon" :color="route.path.indexOf('/profile') != -1 ? 'primary' : 'BW-500'" size="24"/>
              <span class="footer-nav-label">{{ $t('Главная') }}</span>
            </div>
          </template>
        </v-hover>
      </div>
      <div class="w-100">
        <v-hover>
          <template v-slot:default="{ props }">
            <div v-bind="props" class="footer-nav-content cursor-pointer" @click="openCreate">
              <v-icon :icon="PlusIcon" color="BW-500" size="24"/>
              <span class="footer-nav-label">{{ $t('Создать') }}</span>
            </div>
          </template>
        </v-hover>
      </div>
      <div class="w-100">
        <v-hover>
          <template v-slot:default="{ props }">
            <div v-bind="props" class="footer-nav-content cursor-pointer" :class="{ active: route.path.indexOf('/menu') != -1 }" @click="goToMenu">
              <v-avatar size="24" border="sm" :class="{ hover: route.path.indexOf('/menu') != -1 }" class="avatar">
                <v-img alt="avatar" :src="userStore?.userInfo?.avatar" v-if="userStore?.userInfo?.avatar"></v-img>
                <v-icon size="14" :icon="PlaceholderIcon" v-else/>
              </v-avatar>
              <span class="footer-nav-label">{{ $t('Профиль') }}</span>
            </div>
          </template>
        </v-hover>
      </div>
    </div>

  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/userStore';
import { useTapStore } from '@/stores/tapStore';
import {useDialogStore} from "@/stores/dialogStore.js";
import HomeIcon from "~/assets/icons/home.vue";
import PlusIcon from "~/assets/icons/plus.vue";
import {useRoute, useRouter} from "vue-router";
import PlaceholderIcon from "~/assets/icons/placeholder.vue";
import CreatePage from "@/components/CreatePage.vue";

const route = useRoute()
const router = useRouter()
const userStore = useUserStore();
const tapStore = useTapStore();
const {open} = useDialogStore()
const openCreate = () => open(CreatePage, {new: tapStore.tapList.length === 0})
const goToHome = () => {
  router.push('/profile')
}

const goToMenu = () => {
  router.push('/menu')
}

</script>

<style scoped lang="sass">
.footer
  background: #fff
  border-radius: 0
  position: sticky
  bottom: 0
  &.auth
    border-radius: 12px 12px 0 0
    border-top: 1px solid #F6F6F6
    border-left: 1px solid #F6F6F6
    border-bottom: 1px solid #F6F6F6
  .auth
    box-sizing: border-box
    height: 64px
    padding: 7px 8px
  .avatar.hover
    border-color: #0D87EF!important
  .footer-nav-content
    align-items: center
    border-radius: 8px
    box-sizing: border-box
    display: flex
    flex-direction: column
    gap: 0
    height: 50px
    justify-content: center
    padding: 6px 2px
    width: 100%
    &:hover
      background: #F6F7F8
    &.active .footer-nav-label
      color: #0D87EF
  .footer-nav-label
    color: #6C757D
    font-size: 10px
    line-height: 14px
  .rigths
    color: #363636
    font-size: 14px
    font-weight: 400
    line-height: normal
    margin: 0 70px
</style>
